"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ActionContainer = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _rem = _interopRequireDefault(require("polished/lib/helpers/rem"));

var _designTokens = _interopRequireDefault(require("@decisiv/design-tokens"));

var _constants = require("./constants");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var _designTokens$color = _designTokens.default.color,
    baseColors = _designTokens$color.base,
    interactionColors = _designTokens$color.interaction;
var borderRadius = (0, _styledComponents.css)(["border-radius:0 ", " ", " 0;"], (0, _rem.default)(10), (0, _rem.default)(10));

var Action = _styledComponents.default.div.withConfig({
  displayName: "Action",
  componentId: "sc-53eucd-0"
})(["align-items:center;justify-content:center;border:0;color:", ";display:flex;height:100%;width:", ";padding-right:", ";outline:none;", ""], (0, _toColorString.default)(interactionColors.pacificOcean), (0, _rem.default)(_constants.ACTION_WIDTH), (0, _rem.default)(1), borderRadius);

var ActionContainer = _styledComponents.default.div.withConfig({
  displayName: "Action__ActionContainer",
  componentId: "sc-53eucd-1"
})(["height:100%;background-color:", ";", ";"], (0, _toColorString.default)(baseColors.snowWhite), borderRadius);

exports.ActionContainer = ActionContainer;
var _default = Action;
exports.default = _default;